import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  listChannels,
  listConversationGroups,
  listRecentConversations,
} from '../../redux/channels/actions'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { countUnreadTasks } from '../../redux/myTasks/actions'
import {
  clearNotesPanelForce,
  forceOpenNotesPanel,
  setNotesPanelState,
} from '../../redux/notes/actions'
import { isNotesShown, notesPanelForced } from '../../redux/notes/selectors'
import { listPresence } from '../../redux/presence/actions'
import { loadProfile, logoutAsClient } from '../../redux/profile/actions'
import {
  clientInfo,
  isAdminLoggedAsClient,
  isDueDiligenceClient,
  isInitialized,
  isPastClient,
  isSidebarOpen,
  role,
  isProspectUser,
  isIntakeProspectClient,
  user,
  isLoading,
} from '../../redux/profile/selectors'
import { listFavoriteProjects } from '../../redux/taskProjects/actions'
import MainLayout, { IProps } from './MainLayout'

const selector = createStructuredSelector({
  isInitialized,
  role,
  isSidebarOpen,
  isNotesShown,
  isNotesPanelForced: notesPanelForced,
  isAdminLoggedAsClient,
  clientInfo,
  isProspectUser,
  isIntakeProspectClient,
  user,
  isLoading,
  // For the mobile tab bar, which resolves the same per-role menu the rails do.
  isPastClient,
  isDueDiligenceClient,
})
const actions = {
  onInit: loadProfile,
  setNotesPanelState,
  forceOpenNotesPanel,
  clearNotesPanelForce,
  logoutAsClient,
  listChannels,
  listConversationGroups,
  listRecentConversations,
  countUnreadTasks,
  listPresence,
  listFavoriteProjects,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, MainLayout)
